(function(){
  var localeRoot = (window.theme && window.theme.localeRootUrl) || '';
  var MAX_UPSELLS = 4;

  var PHONE_PART_PREFIXES = [
    'pantalla','bateria','batería','touch','flex','conector','puerto','tapa',
    'botones','boton','botón','sensor','lentes','lente','auricular','camara',
    'cámara','microfono','micrófono','vibrador','altavoz','parlante','antena',
    'chasis','marco','carcasa','tornillo','adhesivo','bisel','placa','dock',
    'lector','jack','bocina','buzzer'
  ];
  var GB_RE = /\d+\s?(gb|tb)\b/i;
  var BRAND_RE = /\b(iphone|samsung|usado|nuevo|seminuevo)\b/i;

  function normalize(s){
    return (s == null ? '' : String(s)).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim();
  }

  function isPhone(title){
    if (!title) return false;
    var lower = String(title).toLowerCase();
    var norm = normalize(title);
    for (var i = 0; i < PHONE_PART_PREFIXES.length; i++){
      var p = normalize(PHONE_PART_PREFIXES[i]);
      if (norm.indexOf(p) === 0) return false;
    }
    return BRAND_RE.test(lower) && GB_RE.test(lower);
  }
  window.__scIsPhone = isPhone;

  function escapeHtml(s){
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
    });
  }

  function priceFmt(cents){
    var n = (cents || 0) / 100;
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      try { return window.theme.formatMoney(cents); } catch(e){}
    }
    return 'Q' + n.toFixed(2);
  }

  var GLOBO_API = 'https://related-products.globosoftware.net/v2/public/api';
  var GLOBO_SHOP = (window.Shopify && window.Shopify.shop) || (document.location.host);
  var recCache = {};
  var productCache = {};

  // Mirrors the side-cart-drawer.liquid stock badge logic: a product is
  // shown only if (a) some variant has inventory_quantity >= 1, OR (b) it
  // carries a backorder tag that side cart treats as "available". This is
  // the closest JS-side equivalent to the stock_xela/stock_guatemala
  // metafield logic, since those metafields are not exposed by
  // /products/{handle}.js (Liquid-only) — `available` plus inventory and
  // backorder tags is the canonical signal used by side-cart elsewhere.
  function hasRealStock(p){
    if (!p) return false;
    var tags = (p.tags || []).map(function(t){ return String(t).toLowerCase(); });
    for (var i = 0; i < tags.length; i++){
      if (tags[i] === 'agotado' || tags[i] === 'sold-out' || tags[i] === 'sin-stock') return false;
    }
    var hasBackorder = tags.indexOf('backorder') !== -1 || tags.indexOf('bajopplcd') !== -1 || tags.indexOf('slowback') !== -1 || tags.indexOf('backorder_gt') !== -1;
    if (!p.variants || !p.variants.length) return p.available !== false;
    for (var k = 0; k < p.variants.length; k++){
      var v = p.variants[k];
      if (!v) continue;
      if (v.available === false) continue;
      var q = (typeof v.inventory_quantity === 'number') ? v.inventory_quantity : null;
      if (q === null) return true;             // untracked → trust available
      if (q >= 1) return true;
      if (hasBackorder) return true;
    }
    return false;
  }

  // Fetches a phone PDP and extracts the merchant-curated cubo + cable
  // upsells (the same blocks shown on the product page for iPhone seminuevos).
  // Returns [{handle, variantId}] in the order: cubo first, then cable.
  var pdpUpsellCache = {};
  function fetchPdpUpsells(phoneHandle){
    if (!phoneHandle) return Promise.resolve([]);
    if (pdpUpsellCache[phoneHandle]) return Promise.resolve(pdpUpsellCache[phoneHandle]);
    return fetch(localeRoot + '/products/' + phoneHandle, { credentials:'same-origin' })
      .then(function(r){ return r.ok ? r.text() : ''; })
      .then(function(html){
        if (!html) return [];
        var doc;
        try { doc = new DOMParser().parseFromString(html, 'text/html'); } catch(e){ return []; }
        var out = [];
        ['iphone-cubo-upsell-box','iphone-cable-upsell-box'].forEach(function(id){
          var box = doc.getElementById(id);
          if (!box) return;
          var vid = box.getAttribute('data-variant-id');
          if (!vid || vid === '0') return;
          // Walk up to the surrounding tag-sets wrapper to find the link with the handle.
          var wrap = box.closest('.tag-sets') || box.parentElement;
          var link = wrap ? wrap.querySelector('a[href*="/products/"]') : null;
          var handle = '';
          if (link) {
            var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
            if (m) handle = m[1];
          }
          if (!handle) return;
          out.push({ handle: handle, variantId: parseInt(vid, 10) });
        });
        pdpUpsellCache[phoneHandle] = out;
        return out;
      })
      .catch(function(){ return []; });
  }

  function fetchProductByHandle(handle){
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch(localeRoot + '/products/' + handle + '.js', { credentials:'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .catch(function(){ return null; })
      .then(function(p){ productCache[handle] = p; return p; });
  }

  function fetchGloboRecs(productIds){
    if (!GLOBO_SHOP) return Promise.resolve([]);
    var idList = Array.isArray(productIds) ? productIds : [productIds];
    if (!idList.length) return Promise.resolve([]);
    var qs = '?shop=' + encodeURIComponent(GLOBO_SHOP) +
             '&product_ids=' + encodeURIComponent(idList.join(',')) +
             '&view=globo.related&limit=20';
    return fetch(GLOBO_API + '/getBoughtTogetherProducts' + qs, { credentials:'omit' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(json){
        if (!json || !json.success || !json.data) return [];
        var out = [];
        json.data.forEach(function(item){
          if (!item) return;
          if (item.handle || item.id) {
            out.push({ id: item.id || item.product_id, handle: item.handle || item.product_handle });
          } else if (item.product) {
            out.push({ id: item.product.id, handle: item.product.handle });
          }
        });
        return out;
      })
      .catch(function(){ return []; });
  }

  function fetchShopifyRecs(productId){
    var base = localeRoot + '/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=10';
    return fetch(base + '&intent=complementary', { credentials:'same-origin' })
      .then(function(r){ return r.ok ? r.json() : { products: [] }; })
      .then(function(data){
        var prods = (data && data.products) || [];
        if (prods.length) return prods;
        return fetch(base + '&intent=related', { credentials:'same-origin' })
          .then(function(r){ return r.ok ? r.json() : { products: [] }; })
          .then(function(d2){ return (d2 && d2.products) || []; });
      })
      .catch(function(){ return []; })
      .then(function(prods){
        return prods.map(function(p){ return { id: p.id, handle: p.handle }; });
      });
  }

  function fetchRecs(productId){
    if (recCache[productId]) return Promise.resolve(recCache[productId]);
    return fetchGloboRecs([productId])
      .then(function(globo){
        if (globo && globo.length) return globo;
        return fetchShopifyRecs(productId);
      })
      .then(function(refs){ recCache[productId] = refs; return refs; });
  }

  function fetchRecsBatch(productIds){
    var key = '__batch_' + productIds.slice().sort().join('_');
    if (recCache[key]) return Promise.resolve(recCache[key]);
    return fetchGloboRecs(productIds)
      .then(function(refs){ recCache[key] = refs || []; return recCache[key]; });
  }

  function safeUrl(u){
    if (!u) return '';
    var s = String(u);
    if (/^(https?:)?\/\//i.test(s)) {
      try {
        var parsed = new URL(s, window.location.origin);
        if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return '';
        return escapeHtml(parsed.href);
      } catch(e){ return ''; }
    }
    if (s.charAt(0) === '/') return escapeHtml(s);
    return '';
  }

  function firstAvailableVariant(p){
    if (!p || !p.variants || !p.variants.length) return null;
    for (var i = 0; i < p.variants.length; i++){
      var v = p.variants[i];
      if (!v) continue;
      if (v.available !== false) return v;
    }
    return p.variants[0] || null;
  }

  function renderCard(p){
    // Prefer an explicit variant id captured upstream (e.g. from the PDP
    // upsell block) so we add the exact same variant the merchant configured.
    var v = firstAvailableVariant(p) || {};
    var vid = (p.__forcedVariantId) || v.id;
    if (!vid) return '';
    var img = '';
    if (p.featured_image) {
      img = (typeof p.featured_image === 'string') ? p.featured_image : (p.featured_image.url || '');
    } else if (p.images && p.images.length) {
      img = (typeof p.images[0] === 'string') ? p.images[0] : (p.images[0].src || '');
    }
    if (img && img.indexOf('?') === -1 && img.indexOf('.gif') === -1) {
      img = img.replace(/(\.(jpe?g|png|webp))(\?.*)?$/i, '_160x$1$3');
    }
    img = safeUrl(img);
    var url = safeUrl(p.url || (p.handle ? '/products/' + p.handle : ''));
    var priceCents = (typeof p.price === 'number') ? p.price : (v.price || 0);
    var compareCents = (typeof p.compare_at_price === 'number') ? p.compare_at_price : (v.compare_at_price || 0);
    var hasCompare = compareCents && compareCents > priceCents;

    return '' +
      '<div class="sc-upsell-card" data-sc-upsell-pid="' + p.id + '">' +
        '<div class="sc-upsell-card__body">' +
          '<a href="' + url + '" class="sc-upsell-card__img-wrap" tabindex="-1">' +
            (img ? '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
          '</a>' +
          '<div class="sc-upsell-card__info">' +
            '<a href="' + url + '" class="sc-upsell-card__title">' + escapeHtml(p.title) + '</a>' +
            '<div class="sc-upsell-card__price">' +
              (hasCompare
                ? '<span class="sc-upsell-card__price-sale" data-money-convertible>' + priceFmt(priceCents) + '</span>' +
                  '<span class="sc-upsell-card__price-compare" data-money-convertible>' + priceFmt(compareCents) + '</span>'
                : '<span class="sc-upsell-card__price-regular" data-money-convertible>' + priceFmt(priceCents) + '</span>'
              ) +
            '</div>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="sc-upsell-card__btn" data-sc-action="add-upsell" data-sc-upsell-vid="' + vid + '" data-sc-upsell-title="' + escapeHtml(p.title) + '">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
          'Agregar al carrito' +
        '</button>' +
      '</div>';
  }

  function renderInto(container, list, title){
    var cards = list.map(renderCard).join('');
    container.innerHTML =
      '<div class="sc-upsells">' +
        '<button type="button" class="sc-upsells__toggle" aria-expanded="true" aria-controls="sc-upsells-body-dyn">' +
          '<span class="sc-upsells__title">' + escapeHtml(title || 'Te puede interesar') + '</span>' +
          '<svg class="sc-upsells__chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>' +
        '</button>' +
        '<div class="sc-upsells__body" id="sc-upsells-body-dyn">' +
          '<div class="sc-upsells__list-wrap">' +
            '<div class="sc-upsells__list">' + cards + '</div>' +
          '</div>' +
        '</div>' +
      '</div>';

    var toggle = container.querySelector('.sc-upsells__toggle');
    if (toggle) {
      toggle.addEventListener('click', function(){
        var wrap = container.querySelector('.sc-upsells');
        if (wrap) wrap.classList.toggle('sc-upsells--collapsed');
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    }

    bindDynamicAddButtons(container);

    document.dispatchEvent(new CustomEvent('sc:dynamic-upsells-rendered', { bubbles: true }));
  }

  function bindDynamicAddButtons(container){
    container.querySelectorAll('[data-sc-action="add-upsell"]').forEach(function(btn){
      btn.onclick = function(){
        var vid = btn.getAttribute('data-sc-upsell-vid');
        if (!vid) return;
        var card = btn.closest('.sc-upsell-card');
        if (card) card.classList.add('sc-upsell-card--adding');
        var originalHTML = btn.innerHTML;
        btn.disabled = true;
        btn.innerHTML = '<svg class="atc-spinner" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg> Agregando…';
        fetch(localeRoot + '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1, properties: { '_added_from': 'side-cart-upsell' } }),
          credentials: 'same-origin'
        })
        .then(function(r){
          if (!r.ok) return r.text().then(function(t){ throw new Error('cart/add ' + r.status + ': ' + t); });
          return r.json();
        })
        .then(function(){
          softRefreshSideCart();
        })
        .catch(function(err){
          if (window.console && console.warn) console.warn('[side-cart upsell add failed]', err);
          if (card) card.classList.remove('sc-upsell-card--adding');
          btn.disabled = false;
          btn.innerHTML = originalHTML;
          alert('No se pudo agregar el producto. Intenta de nuevo.');
        });
      };
    });
  }

  function softRefreshSideCart(){
    // Delegate to side-cart.js's refresh which handles full rebind of
    // quantity/remove handlers, map state reset, money convert, etc.
    if (window.SideCart && typeof window.SideCart.refresh === 'function') {
      window.SideCart.refresh(function(){
        document.dispatchEvent(new CustomEvent('cart:rerendered', { bubbles: true }));
      });
      return;
    }
    // Defensive fallback if side-cart.js failed to load.
    var drawer = document.getElementById('side-cart-drawer');
    if (!drawer) return;
    window.location.reload();
  }

  var loadingPromise = null;
  var loadToken = 0;

  function loadDynamic(){
    var myToken = ++loadToken;
    if (loadingPromise) return loadingPromise;
    var container = document.querySelector('[data-sc-upsells-dynamic]');
    if (!container) return Promise.resolve();

    loadingPromise = fetch(localeRoot + '/cart.js', { credentials:'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(cart){
        if (!cart || !cart.items || !cart.items.length) return [];

        var inCartIds = {};
        cart.items.forEach(function(it){ inCartIds[String(it.product_id)] = true; });

        var phoneIds = [];
        var phoneHandles = [];
        var otherIds = [];
        var seenSourceIds = {};
        cart.items.forEach(function(it){
          var pid = String(it.product_id);
          if (seenSourceIds[pid]) return;
          seenSourceIds[pid] = true;
          var t = it.product_title || it.title || '';
          if (isPhone(t)) {
            phoneIds.push(it.product_id);
            if (it.handle) phoneHandles.push(it.handle);
          } else {
            otherIds.push(it.product_id);
          }
        });

        var ordered = phoneIds.concat(otherIds);
        if (!ordered.length) return [];

        // Gating: dynamic Globo/Shopify recs only run when there is at least
        // one phone in the cart (so the side cart can surface the curated
        // cubo + cable from the phone PDP). For carts without a phone, we
        // skip dynamic entirely so the merchant-curated theme editor slots
        // (rendered server-side as the static fallback block) take over.
        if (phoneIds.length === 0) return [];

        // When the source is a phone, accessory upsells are wanted (cubo,
        // cable, etc.). Globo's bought-together often returns more phones,
        // which is not useful — filter those out so only accessories remain.
        // If the source is not a phone, no title-based filter is applied.
        function processRefs(refs, seen, combined, sourceIsPhone){
          function nextRef(j){
            if (j >= refs.length || combined.length >= MAX_UPSELLS) return Promise.resolve();
            var ref = refs[j];
            if (!ref) return nextRef(j+1);
            var pidEarly = ref.id ? String(ref.id) : null;
            if (pidEarly && (inCartIds[pidEarly] || seen[pidEarly])) return nextRef(j+1);
            if (!ref.handle) return nextRef(j+1);
            return fetchProductByHandle(ref.handle).then(function(p){
              if (!p) return nextRef(j+1);
              var pid = String(p.id);
              if (inCartIds[pid] || seen[pid]) return nextRef(j+1);
              if (p.available === false) return nextRef(j+1);
              if (!hasRealStock(p)) return nextRef(j+1);
              if (sourceIsPhone && isPhone(p.title || '')) return nextRef(j+1);
              if (ref.variantId) p.__forcedVariantId = ref.variantId;
              seen[pid] = true;
              combined.push(p);
              return nextRef(j+1);
            });
          }
          return nextRef(0);
        }

        // PRIMARY source for phones: the merchant-curated cubo + cable upsells
        // configured per-product in the PDP section settings (upsell_iphone_cubo,
        // upsell_iphone_cable_usbc/lightning). Scrape them from the phone's PDP
        // HTML so the side cart shows exactly the same accessories the PDP does.
        function gatherPdpRefs(){
          if (!phoneHandles.length) return Promise.resolve([]);
          return Promise.all(phoneHandles.map(fetchPdpUpsells)).then(function(lists){
            var out = []; var seenH = {};
            lists.forEach(function(list){
              (list || []).forEach(function(r){
                if (!r || !r.handle || seenH[r.handle]) return;
                seenH[r.handle] = true;
                out.push(r);
              });
            });
            return out;
          });
        }

        function step(i, seen, combined){
          if (i >= ordered.length || combined.length >= MAX_UPSELLS) return Promise.resolve(combined);
          var srcIsPhone = i < phoneIds.length;
          return fetchRecs(ordered[i]).then(function(refs){
            return processRefs(refs, seen, combined, srcIsPhone).then(function(){ return step(i + 1, seen, combined); });
          });
        }

        var seen = {};
        var combined = [];
        return gatherPdpRefs()
          .then(function(pdpRefs){ return processRefs(pdpRefs, seen, combined, phoneIds.length > 0); })
          .then(function(){
            if (combined.length >= MAX_UPSELLS) return combined;
            return phoneIds.length ? fetchRecsBatch(phoneIds) : Promise.resolve([]);
          })
          .then(function(batchRefs){
            if (combined.length >= MAX_UPSELLS) return combined;
            return processRefs(batchRefs || [], seen, combined, phoneIds.length > 0).then(function(){ return combined; });
          })
          .then(function(){
            if (combined.length >= MAX_UPSELLS) return combined;
            return step(0, seen, combined);
          })
          .then(function(){
            // Fill any remaining slots with the merchant-curated theme editor
            // handles (settings.side_cart_upsell_1..4). These are exposed by
            // side-cart-upsells.liquid as window.theme.sideCartStaticUpsellHandles.
            if (combined.length >= MAX_UPSELLS) return combined;
            var handles = (window.theme && window.theme.sideCartStaticUpsellHandles) || [];
            if (!handles.length) return combined;
            var staticRefs = handles.map(function(h){ return { handle: h }; });
            return processRefs(staticRefs, seen, combined, false).then(function(){ return combined; });
          });
      })
      .then(function(combined){
        loadingPromise = null;
        if (myToken !== loadToken) return;
        var liveContainer = document.querySelector('[data-sc-upsells-dynamic]');
        var liveFallback = document.querySelector('[data-sc-upsells-fallback]');
        if (!liveContainer) return;
        var liveTitle = liveContainer.getAttribute('data-sc-upsells-title') || 'Te puede interesar';
        if (!combined || !combined.length) {
          liveContainer.innerHTML = '';
          if (liveFallback) liveFallback.style.display = '';
          return;
        }
        renderInto(liveContainer, combined, liveTitle);
        if (liveFallback) liveFallback.style.display = 'none';
      })
      .catch(function(){
        loadingPromise = null;
        if (myToken !== loadToken) return;
        var liveContainer = document.querySelector('[data-sc-upsells-dynamic]');
        var liveFallback = document.querySelector('[data-sc-upsells-fallback]');
        if (liveContainer) liveContainer.innerHTML = '';
        if (liveFallback) liveFallback.style.display = '';
      });

    return loadingPromise;
  }

  window.SideCartDynamicUpsells = { load: loadDynamic, isPhone: isPhone };

  document.addEventListener('cart:rerendered', function(){
    setTimeout(loadDynamic, 50);
  });

  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-action="toggle-mini-cart"], .header__cart-toggle');
    if (t) setTimeout(loadDynamic, 250);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(loadDynamic, 400); });
  } else {
    setTimeout(loadDynamic, 400);
  }
})();
